/* Ration24 · Varianten-abhängige Inhalte (Set-Inhalt im Kaufbereich, aktive Spalte der Lieferumfang-Tabelle).
   Liest die gewählten Werte aus dem Horizon-Variantenwähler. Als Modul geladen, läuft nur einmal je Seite. */
const r24Norm = (s) => (s || '').toString().replace(/\s+/g, ' ').trim().toLowerCase();

function r24Gewaehlt() {
  const werte = [];
  document
    .querySelectorAll('variant-picker fieldset input:checked, variant-picker select')
    .forEach((el) => werte.push(r24Norm(el.value)));
  return werte;
}

function r24Anwenden() {
  const werte = r24Gewaehlt();
  if (!werte.length) return;
  document.querySelectorAll('[data-r24-set]').forEach((kasten) => {
    const panels = kasten.querySelectorAll('[data-r24-variante]');
    let treffer = null;
    panels.forEach((p) => {
      if (werte.includes(r24Norm(p.dataset.r24Variante))) treffer = p;
    });
    if (!treffer) return;
    panels.forEach((p) => {
      p.hidden = p !== treffer;
    });
  });
  document.querySelectorAll('[data-r24-spalte]').forEach((zelle) => {
    zelle.classList.toggle('ist-aktiv', werte.includes(r24Norm(zelle.dataset.r24Spalte)));
  });
}

document.addEventListener('change', (e) => {
  const ziel = e.target;
  if (ziel instanceof Element && ziel.closest('variant-picker')) requestAnimationFrame(r24Anwenden);
});
r24Anwenden();
